/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};



/******/ })()
;

function refreshRecTitle(e){
  let refreshText = document.querySelectorAll('.cart_upsaling_title h6');
   for(let i =0; i<refreshText.length; i++){
      if(refreshText[i].hasAttribute('data-sm-age')) continue; // age-matched title is set by the theme
      if(e <= 0){
         refreshText[i].textContent="Would you like to add?";
      }
      else{
         refreshText[i].textContent="Would you like to add this too?"; 
      }
   }
}

document.querySelectorAll('#copy-link-btn').forEach(function(btn){ btn.addEventListener("click", function(event) {
  // Prevent the default behavior of the anchor tag
  event.preventDefault();

  // Get the current URL
  var url = window.location.href;
  
  // Create a temporary input element
  var input = document.createElement("input");
  input.style.position = "fixed";
  input.style.opacity = 0;
  input.value = url;
  document.body.appendChild(input);
  
  // Select the URL text
  input.select();
  input.setSelectionRange(0, 99999); // For mobile devices
  
  // Copy the URL to the clipboard
  document.execCommand("copy");
  
  // Remove the temporary input
  document.body.removeChild(input);
  
  // Optionally, provide some visual feedback
  alert("URL copied to clipboard: " + url);
}); });